<template>
    <div class="layout--full-page">
      <router-view></router-view>
      <Footer></Footer>
    </div>
</template>
<script>
import Footer from "../components/FullPageFooter.vue";

export default {
    data() {
        return {
            
        }
    },
    components: {
        Footer
    }
}
</script>